/**
 * Simple Logic Multi Guard for Vue Router
 * Credit to Original Author
 * @see https://github.com/atanas-dev/vue-router-multiguard/blob/master/index.js
 * @param value
 * @returns {boolean}
 */
function isUndefined(value) {
  return value === undefined
}

/**
 * @desc Recursive Guard Evaluator to Evaluate each guard function params
 * e.g. of a guards param:
 * guards = []
 * guards = [func1, func2...]
 * guards = [[func1, arg1, arg2...], func2...]
 *   for this, your func1(to, from, next, arg1, arg2) based on your requirement
 * @param guards
 * @param to
 * @param from
 * @param next
 */
function evaluateGuards(guards, to, from, next) {
  const guardsLeft = guards.slice(0) // clone the array so we do not accidentally modify it
  const nextGuard = guardsLeft.shift()

  if (isUndefined(nextGuard)) {
    next()
    return
  }

  // check if the nextGuard is funcN or [funcN, argN...]
  // if it is with arguments, the first element is function ref
  // the second and next elements are argument
  if(Array.isArray(nextGuard)) {
    nextGuard[0](to, from, (nextArg) => {
      if (isUndefined(nextArg)) {
        evaluateGuards(guardsLeft, to, from, next)
        return
      }

      next(nextArg)
    }, ...nextGuard.slice(1))
  } else {
    nextGuard(to, from, (nextArg) => {
      if (isUndefined(nextArg)) {
        evaluateGuards(guardsLeft, to, from, next)
        return
      }

      next(nextArg)
    })
  }
}

/**
 * @desc Multi-guard dispatcher
 * @see evaluateGuards
 * @param guards
 * @returns {function(*=, *=, *=): undefined}
 */
export function multiGuards(guards) {
  return (to, from, next) => {
    return evaluateGuards(guards, to, from, next)
  }
}
